(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Beam menu enhancements: add SHOP BY CATEGORY text + submenu_* classes on Shop items
  function beamEnhanceMenus() {
    try {
      function beamSlug(text) {
        return text
          .toLowerCase()
          .trim()
          .replace(/\s+/g, '-')
          .replace(/[^a-z0-9\-]/g, '');
      }

      function enhanceDesktopShopMenu() {
        var headerMenus = document.querySelectorAll('.header__inline-menu details');

        headerMenus.forEach(function (details) {
          var summarySpan = details.querySelector('summary span');
          if (!summarySpan) return;

          var title = summarySpan.textContent.trim().toLowerCase();
          if (title !== 'shop') return;

          var submenu = details.querySelector('ul');
          if (!submenu) return;

          if (!submenu.querySelector('.beam-shop-title')) {
            var p = document.createElement('p');
            p.className = 'beam-shop-title';
            p.textContent = 'SHOP BY CATEGORY';
            submenu.insertBefore(p, submenu.firstChild);
          }

          submenu.querySelectorAll('li').forEach(function (li) {
            var link = li.querySelector('a');
            if (!link) return;
            var text = link.textContent.trim();
            if (!text) return;

            var slug = beamSlug(text);
            if (!slug) return;

            li.classList.add('submenu_' + slug);
            link.classList.add('submenu_item_' + slug);
          });
        });
      }

      function enhanceDrawerShopMenu() {
        var drawerMenus = document.querySelectorAll('.menu-drawer__menu');

        drawerMenus.forEach(function (menu) {
          var parentDetails = menu.closest('details');
          if (!parentDetails) return;

          var summarySpan = parentDetails.querySelector('summary span');
          if (!summarySpan) return;

          var title = summarySpan.textContent.trim().toLowerCase();
          if (title !== 'shop') return;

          if (!menu.querySelector('.beam-shop-title')) {
            var p = document.createElement('p');
            p.className = 'beam-shop-title';
            p.textContent = 'SHOP BY CATEGORY';
            menu.insertBefore(p, menu.firstChild);
          }

          menu.querySelectorAll('li').forEach(function (li) {
            var link = li.querySelector('a');
            if (!link) return;
            var text = link.textContent.trim();
            if (!text) return;

            var slug = beamSlug(text);
            if (!slug) return;

            li.classList.add('submenu_' + slug);
            link.classList.add('submenu_item_' + slug);
          });
        });
      }

      enhanceDesktopShopMenu();
      enhanceDrawerShopMenu();
    } catch (e) {
      if (window.console && console.warn) {
        console.warn('Beam menu enhancement error', e);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', beamEnhanceMenus);
  } else {
    beamEnhanceMenus();
  }

  } catch(e) { console.error(e); }
})();
})();
